import { sortAvailableLocales } from 'modules/auth/lib/signup/sortAvailableLocales'
import { IconCountryFlag } from 'modules/common/components/_icons/IconCountryFlag/IconCountryFlag'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { RadioButton } from 'modules/common/components/_ui/FormControl/RadioButton/RadioButton'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import { EnumRoutes } from 'modules/common/routes'
import { MandatoryInformationCard } from 'modules/onboarding/components/MandatoryInformationCard/MandatoryInformationCard'
import { useRouter } from 'next/router'
import { useState } from 'react'

export const SignupDomiciliationContainer = () => {
  const { t } = useTranslation('auth-components')

  const router = useRouter()

  const userLocale = useUserLocale()

  const [selectedLocale, setSelectedLocale] = useState(userLocale)

  const sortedLocales = sortAvailableLocales(userLocale)

  const onBack = () => history.back()

  const confirm = () => {
    router.push(EnumRoutes.SIGNUP_INFORMATION, EnumRoutes.SIGNUP_INFORMATION, {
      locale: selectedLocale,
    })
  }

  return (
    <MandatoryInformationCard
      illustrationName="society"
      title={t('signupDomiciliationContainer.card.title')}
    >
      <div>
        {sortedLocales.map((locale) => (
          <RadioButton
            key={locale}
            id={locale}
            value={locale}
            name="locale"
            variant="outline"
            checked={locale === selectedLocale}
            onChange={() => setSelectedLocale(locale)}
            icon={<IconCountryFlag className="h-8 w-8" locale={locale} />}
            primaryLabelClassName="flex items-center gap-4"
            primaryLabel={t('signupDomiciliationContainer.card.locales.label', {
              context: locale,
            })}
          />
        ))}
      </div>
      <div className="flex gap-4">
        <Button
          className="flex-1"
          variant="secondary"
          color="default"
          onClick={onBack}
        >
          {t('signupDomiciliationContainer.card.cta.goBack')}
        </Button>
        <Button
          className="flex-1"
          variant="primary"
          color="default"
          onClick={confirm}
        >
          {t('signupDomiciliationContainer.card.cta.confirm')}
        </Button>
      </div>
    </MandatoryInformationCard>
  )
}
